<template>
         <v-dialog @input='status' v-model="deleteDialogData" max-width="290">
        <v-card>
          <v-card-title style="color:red" class="headline">Change Status</v-card-title>
          <v-card-text>
            <v-select v-model="statusTochange" :items="statusList" label="Select Status"></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat="flat"
              @click="deleteBulk()"
            >Change Status</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapFields } from "vuex-map-fields";
export default {
    props : {
        inputData : Array,
        deleteDialog : Boolean
    },
    watch: { 
      deleteDialog: function(newVal, oldVal) { 
         this.deleteDialogData = newVal;
        }
      },
    data(){
        return{
        deleteDialogData : false,
        statusTochange:"Recycled",
        statusList: [
        "Recycled",
        "Sold",
        "Ready to Image",
        "Needs repair",
        "Active"
      ],
        }
    },
      computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor"])
  },
    methods : {
        status(val){
           if (val===false){
               this.$emit('dialogclose')
           }
        },
        deleteBulk() {
      this.inputData.forEach(input => {
        //remove asset from location if any
        fb.LocationsCollections.where(
          "assets",
          "array-contains",
          input.Discovery.AssetTag
        )
          .get()
          .then(items => {
            if (items.empty !== true) {
              items.forEach(item => {
                var docID = item.AssetTag;
                var collection = item.data().assets;
                collection = collection.filter(target => {
                  return target !== input.Discovery.AssetTag;
                });
                fb.LocationsCollections.doc(docID).update({
                  assets: collection
                });
              });
            }
            this.deleteDialogData = false
            this.snackBarcolor = "success";
            this.snackBarMessage = "Asset "+input.Discovery.AssetTag+" is now marked as "+this.statusTochange;
            this.snackBar = true;
          });
        //mark asset as recycled
        fb.AssetsCollections.doc(input.Discovery.AssetTag).update({
          ["Discovery.location"]: "",
          ["Discovery.Status"]: this.statusTochange
        });
      });
    },
    }
}
</script>
